(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const YAPARFUM_IMAGE_PAUSE_MS = 3000;
const YAPARFUM_IMAGE_FADE_MS = 800;

if (!customElements.get('yaparfum-card-hover')) {
  customElements.define('yaparfum-card-hover', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.parentElement;
      this.events = new AbortController();
      this.version = (this.version ?? 0) + 1;
      this.failedImages = new Set();

      const options = { signal: this.events.signal };
      this.gallery.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.failedImages.clear();
        this.schedule(this.version);
      }, options);
      this.gallery.addEventListener('pointerleave', () => this.stop(), options);
      this.gallery.addEventListener('pointerdown', () => this.stop(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
      }, options);
      window.addEventListener('blur', () => this.stop(), options);
      matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => this.stop(), options);
    }

    disconnectedCallback() {
      this.stop();
      this.events?.abort();
    }

    stop() {
      this.version += 1;
      clearTimeout(this.timer);
      this.animation?.cancel();
      this.incomingAnimation?.cancel();
      this.snapshot?.remove();
      this.animation = null;
      this.incomingAnimation = null;
      this.snapshot = null;
    }

    isActive(version) {
      return version === this.version && this.isConnected &&
        this.gallery.matches(':hover') && !document.hidden &&
        !matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    schedule(version) {
      if (!this.isActive(version)) return;
      this.timer = setTimeout(() => this.advance(version), YAPARFUM_IMAGE_PAUSE_MS);
    }

    async imageReady(image) {
      image.loading = 'eager';
      if (image.complete && image.naturalWidth > 0) return;
      let timeout;
      try {
        await Promise.race([
          image.decode(),
          new Promise((_, reject) => {
            timeout = setTimeout(() => reject(new Error('Image load timeout')), 10000);
          }),
        ]);
        if (!image.naturalWidth) throw new Error('Image unavailable');
      } finally {
        clearTimeout(timeout);
      }
    }

    async advance(version) {
      if (!this.isActive(version)) return;
      const slideshow = this.gallery.querySelector('slideshow-component');
      if (!slideshow || typeof slideshow.select !== 'function') return;
      const slides = Array.from(slideshow.slides || []);
      const current = slides[slideshow.current];
      const images = slides.filter((slide) =>
        slide.classList.contains('product-media-container--image') &&
        slide.querySelector('img') && !this.failedImages.has(slide)
      );
      if (images.length < 2) return;
      const next = images[(images.indexOf(current) + 1) % images.length];
      const image = next.querySelector('img');

      try {
        await this.imageReady(image);
      } catch {
        this.failedImages.add(next);
        this.schedule(version);
        return;
      }

      if (!this.isActive(version)) return;
      if (slideshow.slides?.[slideshow.current] !== current ||
          !slideshow.slides?.includes(next)) {
        this.schedule(version);
        return;
      }

      const previousImage = current?.querySelector('img');
      let snapshot;
      let animation;
      let incomingAnimation;
      try {
        if (previousImage?.complete && previousImage.naturalWidth > 0) {
          const bounds = previousImage.getBoundingClientRect();
          const galleryBounds = this.gallery.getBoundingClientRect();
          const appearance = getComputedStyle(previousImage);
          snapshot = new Image();
          snapshot.src = previousImage.currentSrc || previousImage.src;
          snapshot.alt = '';
          snapshot.setAttribute('aria-hidden', 'true');
          snapshot.className = 'yaparfum-hover-snapshot';
          Object.assign(snapshot.style, {
            left: (bounds.left - galleryBounds.left - this.gallery.clientLeft) + 'px',
            top: (bounds.top - galleryBounds.top - this.gallery.clientTop) + 'px',
            width: bounds.width + 'px',
            height: bounds.height + 'px',
            objectFit: appearance.objectFit,
            objectPosition: appearance.objectPosition,
            borderRadius: appearance.borderRadius,
          });
          this.gallery.append(snapshot);
          this.snapshot = snapshot;
        }

        incomingAnimation = image.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: YAPARFUM_IMAGE_FADE_MS,
          easing: 'ease-in-out',
          fill: 'both',
        });
        incomingAnimation.pause();
        this.incomingAnimation = incomingAnimation;
        await slideshow.select({ id: next.getAttribute('slide-id') }, undefined, { animate: false });
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (!this.isActive(version)) return;
        incomingAnimation.play();

        if (snapshot) {
          animation = snapshot.animate([{ opacity: 1 }, { opacity: 0 }], {
            duration: YAPARFUM_IMAGE_FADE_MS,
            easing: 'ease-in-out',
            fill: 'forwards',
          });
          this.animation = animation;
          await animation.finished;
        }
      } catch {
      } finally {
        animation?.cancel();
        incomingAnimation?.cancel();
        snapshot?.remove();
        if (this.snapshot === snapshot) this.snapshot = null;
        if (this.animation === animation) this.animation = null;
        if (this.incomingAnimation === incomingAnimation) this.incomingAnimation = null;
      }
      this.schedule(version);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
